const BaseConfig = {
  persistNavigation: "dev",
  catchErrors: "always",
  exitRoutes: ["dashboard"],
}

export default BaseConfig
